import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AcademicsComponent } from 'src/app/view/beyond/academics/academics.component';
import { BeyondComponent } from 'src/app/view/beyond/beyond.component';
import { CelebrationComponent } from 'src/app/view/beyond/celebration/celebration.component';
import { ClubsComponent } from 'src/app/view/beyond/clubs/clubs.component';
import { CompetitionComponent } from 'src/app/view/beyond/competition/competition.component';
import { ExaminationComponent } from 'src/app/view/beyond/examination/examination.component';
import { PtmComponent } from 'src/app/view/beyond/ptm/ptm.component';
import { StudentCouncilComponent } from 'src/app/view/beyond/student-council/student-council.component';
import { TripComponent } from 'src/app/view/beyond/trip/trip.component';
import { WorkshopComponent } from 'src/app/view/beyond/workshop/workshop.component';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [
    BeyondComponent,
    AcademicsComponent,
    ExaminationComponent,
    CompetitionComponent,
    CelebrationComponent,
    WorkshopComponent,
    PtmComponent,
    TripComponent,
    ClubsComponent,
    StudentCouncilComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild([
      {path:'',component:BeyondComponent,children:[
        {path:'academic',component:AcademicsComponent},
        {path:'examination',component:ExaminationComponent},
        {path:'competition',component:CompetitionComponent},
        {path:'celebration',component:CelebrationComponent},
        {path:'workshop',component:WorkshopComponent},
        {path:'ptm',component:PtmComponent},
        {path:'trip',component:TripComponent},
        {path:'clubs',component:ClubsComponent},
        {path:'council',component:StudentCouncilComponent}
      ]}
    ])
  ]
})
export class BeyondModule { }
